import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { GetUserToken } from '../models/token';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { UserItem } from '../../api/models';
import { IdentityService } from '../../api/services';
// import { ConfirmationService, MessageService } from 'primeng/api';
import { Router } from '@angular/router';
import { enumUserRole } from '../../shared/utils/enum-user-role';
import { NotificationSignalService } from '../../shared/services/notification-signal.service';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private readonly SS_KEY = 'st-tk'; // Chiave usata per salvare il token JWT in localStorage
  identity: BehaviorSubject<GetUserToken | undefined> = new BehaviorSubject<
    GetUserToken | undefined
  >(undefined); // Contiene il token JWT decodificato
  user: BehaviorSubject<UserItem | undefined> = new BehaviorSubject<
    UserItem | undefined
  >(undefined); // Contiene l’oggetto utente caricato da getMyself()
  enumUserRole = enumUserRole;
  jwt_token?: string; // Copia in memoria del token salvato

  constructor(
    private jwt: JwtHelperService,
    private identityService: IdentityService,
    private notificationSignalService: NotificationSignalService,
    private router: Router,

    @Inject(PLATFORM_ID) private platformId: any,

    @Inject(DOCUMENT) private document: Document
  ) {
    if (this.isBrowser()) {
      const token = this.getToken();
      // Se il token esiste ed è valido
      if (token && !this.jwt.isTokenExpired(token)) {
        // Decodifica il token e lo salva in memoria
        this.jwt_token = token;
        const decoded = this.jwt.decodeToken(token);
        if (decoded) {
          this.identity.next(decoded);
        }
      } else {
        // Se è scaduto o assente, lo rimuove
        this.clearToken();
      }
    }
  }

  isBrowser() {
    // Controllare se siamo in ambiente browser (es. durante il rendering client-side) piuttosto che in ambiente server (es. Angular Universal, SSR).
    return isPlatformBrowser(this.platformId);
  }

  getStorage() {
    // Restituisce localStorage solo se siamo in browser, per evitare errori in SSR
    if (isPlatformBrowser(this.platformId)) {
      return this.document.defaultView?.localStorage;
    }
    return undefined;
  }

  getToken() {
    // Legge il token dal localStorage usando SS_KEY
    return this.getStorage()?.getItem(this.SS_KEY) ?? undefined;
  }

  storeUser(token: string) {
    // Setto il token JWT in memoria e nel localStorage
    this.jwt_token = token;
    this.getStorage()?.setItem(this.SS_KEY, token);

    const jwtDecoded = this.jwt.decodeToken(token);
    // Se il token non è valido o non è stato decodificato, esegue il logout
    if (!jwtDecoded) {
      this.logout();
      return;
    }
    this.setIdentity(jwtDecoded);
  }

  setIdentity(jwtDecoded: any) {
    this.identity.next(jwtDecoded);
    this.notificationSignalService.start();
  }

  hasToken() {
    return !!this.getToken();
  }

  isLogged() {
    return this.user.value !== undefined;
  }

  getUser() {
    return this.user.value!;
  }

  getUserId() {
    return this.getUser().id;
  }

  logout() {
    this.jwt_token = undefined;
    this.identity.next(undefined);
    this.user.next(undefined);
    this.notificationSignalService.stop();

    this.getStorage()?.removeItem(this.SS_KEY);
  }

  clearToken(): void {
    this.jwt_token = undefined;
    this.getStorage()?.removeItem(this.SS_KEY);
  }

  getMyself(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.identityService.identityControllerGetMyself().subscribe({
        next: (res) => {
          this.user.next(res.data);
          resolve(true);
        },
        error: () => {
          this.logout();
          reject(false);
        },
      });
    });
  }

  isAnyTourLeader() {
    // debugger
    return (
      this.user.value &&
      (this.user.value.role.id === enumUserRole.TOURLEADER ||
        this.user.value.role.id === enumUserRole.TOURLEADER_PRO)
    );
  }
  isTourLeader() {
    return (
      this.user.value && this.user.value.role.id === enumUserRole.TOURLEADER
    );
  }
  isTourLeaderPro() {
    return (
      this.user.value && this.user.value.role.id === enumUserRole.TOURLEADER_PRO
    );
  }

  isProfileCompleted() {
    // debugger
    if (!this.user.value) {
      return false;
    }
    if (
      this.user.value.name != null &&
      this.user.value.last_name != null &&
      this.user.value.date_of_birth != null &&
      this.user.value.country != null
    ) {
      return true;
    } else {
      return false;
    }
  }
  isProfileProCompleted() {
    if (!this.user.value) {
      return false;
    }
    if (
      this.user.value.role.id === enumUserRole.TOURLEADER_PRO &&
      this.user.value.related_registry.vat_number != ''
    ) {
      return true;
    } else {
      return false;
    }
  }
}
